import type {ReactElement} from 'react';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import styles from './entity-draft-skeleton.module.scss';

/**
 * Transient placeholder mirroring the entity-draft-card layout, shown while the
 * agent is still composing the draft. Replaced automatically by the streamed
 * intro text / real draft card (it renders as a thinking message).
 */
export function EntityDraftSkeleton(): ReactElement {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <SkeletonBrick className={styles.metaLine} height={14} radius={'4px'} />
        <SkeletonBrick width={56} height={20} radius={'999px'} />
      </div>
      <div className={styles.divider} />
      <SkeletonBrick className={styles.textLineFull} height={14} radius={'4px'} />
      <SkeletonBrick className={styles.textLineShort} height={14} radius={'4px'} />
      <SkeletonBrick className={styles.media} theme={SkeletonBrickTheme.AI_ROTATING_GRADIENT} />
    </div>
  );
}
